"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M5.752 8.292 6.974 6.6h10.052l1.222 1.692A.749.749 0 0 0 18 8.25H6a.749.749 0 0 0-.248.042ZM5.25 9.75h-.752a.75.75 0 0 1-.604-1.19l2.166-3a.746.746 0 0 1 .605-.31h10.67c.24 0 .464.115.605.31l2.166 3a.75.75 0 0 1-.605 1.19h-.75V18a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75V9.75Zm4.677 0c-.412.46-1.01.75-1.677.75a2.244 2.244 0 0 1-1.65-.72v7.62h1.665a.753.753 0 0 1-.015-.15v-4.5A.75.75 0 0 1 9 12h1.5a.75.75 0 0 1 .75.75v4.5a.756.756 0 0 1-.015.15H17.4V9.78c-.41.443-.998.72-1.65.72-.666 0-1.265-.29-1.677-.75h-.396c-.412.46-1.01.75-1.677.75-.666 0-1.265-.29-1.677-.75h-.396ZM13.5 12a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75h2.25a.75.75 0 0 0 .75-.75v-1.5a.75.75 0 0 0-.75-.75H13.5Z",
    clipRule: "evenodd"
  })]
});